import { FBF_CloudCallable } from '@rabbit/firebase/adapter';

export const nestApiGetSecret = FBF_CloudCallable<
  { secretName: string },
  { value?: string; success: boolean; error?: string }
>('api/secrets/get|POST');
